import {
    GREETING_CATEGORY_TAG
  } from "../../constants/actionTypes";
  
  const INIT_STATE = {
    loader: false,
    alertMessage: '',
    messageId: null,
    lists: []
  };
  
  
  export default (state = INIT_STATE, action) => {
    switch (action.type) {
  
      case GREETING_CATEGORY_TAG.RESET_GREETING_CATEGORY_TAG: {
        return {
          ...state,
          loader: false,
          alertMessage: '',
          messageId: null
        }
      }
  
      case GREETING_CATEGORY_TAG.ADD_GREETING_CATEGORY_TAG_REQUEST: {
        return {
          ...state,
          loader: true
        }
      }
  
      case GREETING_CATEGORY_TAG.ADD_GREETING_CATEGORY_TAG_SUCCESS: {
        return {
          ...state,
          loader: false,
          alertMessage: action.payload.message,
          messageId: 200
        }
      }
  
      case GREETING_CATEGORY_TAG.ADD_GREETING_CATEGORY_TAG_FAIL: {
        return {
          ...state,
          loader: false,
          alertMessage: action.payload.message,
          messageId: 203
        }
      }
  
      case GREETING_CATEGORY_TAG.LIST_GREETING_CATEGORY_TAG_REQUEST: {
        return {
          ...state,
          loader: true
        }
      }
  
      case GREETING_CATEGORY_TAG.LIST_GREETING_CATEGORY_TAG_SUCCESS: {
        return {
          ...state,
          loader: false,
          messageId: 204,
          lists: action.payload
        }
      }
  
      case GREETING_CATEGORY_TAG.LIST_GREETING_CATEGORY_TAG_FAIL: {
        return {
          ...state,
          loader: false,
          alertMessage: action.payload.message,
          messageId: 203
        }
      }

      case GREETING_CATEGORY_TAG.GET_ALL_GREETING_CATEGORY_TAG_REQUEST: {
        return {
          ...state,
          loader: true
        }
      }

      case GREETING_CATEGORY_TAG.GET_ALL_GREETING_CATEGORY_TAG_SUCCESS: {
        return {
          ...state,
          loader: false,
          messageId: 204,
          lists: action.payload
        }
      }

      case GREETING_CATEGORY_TAG.GET_ALL_GREETING_CATEGORY_TAG_FAIL: {
        return {
          ...state,
          loader: false,
          alertMessage: action.payload.message,
          messageId: 203
        }
      }
  
      case GREETING_CATEGORY_TAG.DELETE_GREETING_CATEGORY_TAG_REQUEST: {
        return {
          ...state,
          loader: true
        }
      }
  
      case GREETING_CATEGORY_TAG.DELETE_GREETING_CATEGORY_TAG_SUCCESS: {
        return {
          ...state,
          loader: false,
          alertMessage: action.payload.message,
          messageId: 200,
          lists: action.payload.data
        }
      }
  
      case GREETING_CATEGORY_TAG.DELETE_GREETING_CATEGORY_TAG_FAIL: {
        return {
          ...state,
          loader: false,
          alertMessage: action.payload.message,
          messageId: 203
        }
      }
  
      case GREETING_CATEGORY_TAG.UPDATE_GREETING_CATEGORY_TAG_REQUEST: {
        return {
          ...state,
          loader: true
        }
      }
  
      case GREETING_CATEGORY_TAG.UPDATE_GREETING_CATEGORY_TAG_SUCCESS: {
        return {
          ...state,
          loader: false,
          alertMessage: action.payload.message,
          messageId: 200,
          lists: action.payload.data
        }
      }
  
      case GREETING_CATEGORY_TAG.UPDATE_GREETING_CATEGORY_TAG_FAIL: {
        return {
          ...state,
          loader: false,
          alertMessage: action.payload.message,
          messageId: 203
        }
      }

      case GREETING_CATEGORY_TAG.SEARCH_GREETING_CATEGORY_TAG_REQUEST: {
        return {
          ...state,
          loader: true
        }
      }

      case GREETING_CATEGORY_TAG.SEARCH_GREETING_CATEGORY_TAG_SUCCESS: {
        return {
          ...state,
          loader: false,
          messageId: 204,
          lists: action.payload
        }
      }

      case GREETING_CATEGORY_TAG.SEARCH_GREETING_CATEGORY_TAG_FAIL: {
        return {
          ...state,
          loader: false,
          alertMessage: action.payload.message,
          messageId: 203
        }
      }
  
      default:
        return state;
    }
  }
